import styled from 'styled-components';

export const HeaderWrapper = styled.div<{ isRegistering: boolean }>`
  padding-left: ${({ theme }) => theme.spacing.m};
  display: flex;
  align-content: center;
`;

export const LinkHeader = styled.a`
  gap: ${({ theme }) => theme.spacing.s};
  display: flex;
`;

export const HeaderSection = styled.div`
  width: ${({ theme }) => theme.width.full};
  margin-bottom: ${({ theme }) => theme.spacing.m};
  margin-top: ${({ theme }) => theme.spacing.m};
`;
